import { useState, useEffect } from 'react';
import { SilentLogin } from './components/SharedAuthentication';
import DashRoutes from './Routes';
import TopMenu from './components/TopMenu';
//import { useNavigate } from 'react-router-dom';

const App = () => {
    //let navigate = useNavigate();
    const [authState, setAuthState] = useState({ loading: true, user: null });
    const [trySilentLogin, setTrySilentLogin] = useState(false);

    const checkUserSession = async () => {
        try {
            // Check current BFF cookie session
            var req = new Request("/bff/user", {
                headers: new Headers({
                    "X-CSRF": "1",
                }),
            });
            var response = await fetch(req);
            
            if (response.ok) {
                const userData = await response.json();
                setAuthState({ loading: false, user: userData });
            } else {
                // No active session found, try silent login
                setTrySilentLogin(true);
            }
        } catch {
            setTrySilentLogin(true);
        }
    };

    useEffect(() => {
        checkUserSession();
    }, []);

    const handleSilentSuccess = () => {
        setTrySilentLogin(false);
        checkUserSession(); // Re-fetch user data now that the session cookie is set
    };

    const handleSilentFailure = () => {
        setTrySilentLogin(false);
        // Silent login failed (e.g. no active session at IdP), force interactive login
        //navigate("/bff/login");
        window.location.href = "/bff/login";
    };

    if (authState.loading) {
        return (
            <div>
                <p>Loading application...</p>
                {trySilentLogin && (
                    <SilentLogin
                        onLoginSuccess={handleSilentSuccess}
                        onLoginFailure={handleSilentFailure}
                    />
                )}
            </div>
        );
    }

    return (
        <div>
            <TopMenu />
            <DashRoutes/>
        </div>
    );
};

export default App;